import React from 'react';

const HubspotInfo = () => {
  return <span className="text-blue-500">(Hubspot)</span>;
};

export default HubspotInfo;
